import HowToRegIcon from "@mui/icons-material/HowToReg";
import RedirectToTab from "../RedirectToCampaignTab";
import ListRegularCampaigns from "./List";
import { CAMPAIGNS, CandidateServicePath, REGULAR } from "utils/constants";
import CreateRegularCampaign from "./Create";
import EditRegularCampaign from "./Edit";
import permissions from "app/permissions";
import ShowRegularCampaign from "./Show";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: false,
  tenancies: [tenants.MU],
  icon: <HowToRegIcon />,
  name: CandidateServicePath + CAMPAIGNS + `/${REGULAR}`,
  title: "Редовни кампании",
  list: <RedirectToTab type={REGULAR} />,
  tabList: <ListRegularCampaigns />,
  create: <CreateRegularCampaign />,
  createPermission: permissions.canCreateCampaigns,
  edit: <EditRegularCampaign />,
  editPermission: permissions.canUpdateCampaigns,
  show: <ShowRegularCampaign />,
  showPermission: permissions.canPreviewCampaigns,
  permission: permissions.canPreviewCampaigns,
};
